import React from 'react';
import styled from 'styled-components';
import { Checkbox } from 'antd';

const StyledSpan = styled.span`
  margin-left: -5px;
`;

const AggregateCheckBoxView = ({ onChange, cacheEnabled, style = {} }) => (
  <Checkbox onChange={onChange} checked={cacheEnabled} style={style}>
    <StyledSpan>Unique</StyledSpan>
  </Checkbox>
);

export default AggregateCheckBoxView;
